import React from "react";
import { useEvent } from "../events/event/EventProvider";
import "./AllTasks.scss";

const AllTasks = () => {
  const [{ event }] = useEvent();
  
  const taskMap = new Map();
  event.events.forEach((task) => {
    if (!taskMap.has(task.levelId)) {
      taskMap.set(task.levelId, []);
    }
    taskMap.get(task.levelId).push(task);
  });

  return (
    <div className="all_tasks">
      {Object.entries(event.eventNames).map(([levelId, levelData], index) => {
        const tasks = taskMap.get(levelId) || [];
        const taskCount = tasks.length;
        const eventType = index < 2 ? "BADGE" : "NONBADGE";

        return (
          <div className="tasks_container" key={levelId}>
            <h1>{levelData.name}</h1>
            <p className = "level_id">LEVEL ID - {levelId}</p>
            <div className="task_type">
              <p>TYPE - {eventType}</p>
              <p>TASKS - {taskCount}</p>
            </div>
            <div className="task_head">
              <h3>Task Name</h3>
              <h3>Task Key</h3>
            </div>
            {tasks.map((task) => (
              <div className="task_desc" key={task.id}>
                <p>{task.name}</p>
                <p>{task.id}</p>
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default AllTasks;
